import { render, staticRenderFns } from "./AreaItem.vue?vue&type=template&id=22290a8a&"
import script from "./AreaItem.vue?vue&type=script&lang=js&"
export * from "./AreaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports